import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { LocalFaturamentoSelectComponent } from './local-faturamento-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        LocalFaturamentoSelectComponent
    ],
    exports: [
        LocalFaturamentoSelectComponent
    ]
})
export class LocalFaturamentoSelectModule { }
